import { Card, Icon } from '@/components'

import styles from './Card.module.scss'
import { MobileApps } from '@/store/slices/stagesSlice/interfaces'
import { storeLinks } from '@/constants'

interface IPaymentInAppCard {
  mobileApps: MobileApps | null
}

export default function PaymentInAppCard({ mobileApps }: IPaymentInAppCard) {
  return (
    <Card className={styles.paymentHPApp}>
      <div className={styles.content}>
        <header>
          <h3 className={styles.subtitle}>Оплатить через приложение HippoParking</h3>
        </header>
        <section className={styles.mobileApps}>
          {/*<a href={mobileApps ? mobileApps.ios_link : storeLinks.appStore} target="_blank" rel="noreferrer noopener">*/}
          {/*  <Icon name="app-store-icon" />*/}
          {/*</a>*/}
          <a href={mobileApps ? mobileApps.android_link : storeLinks.googlePlay} target="_blank" rel="noreferrer noopener">
            <Icon name="google-play-icon" />
          </a>
        </section>
      </div>
      <div className={styles.image}>
        <Icon name="hp-card" />
      </div>
    </Card>
  )
}
